import React, { useEffect, useState } from "react";
import { Col, Form, Modal, OverlayTrigger, Row } from "react-bootstrap";
import EventModelValidationNew from "./EventModelValidationNew";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { loader } from "../../../../../loader";
import {
  postData,
  updateConsent,
  fetchDataForWebinar,
} from "../../../../../axios/apiHelper";
import { ENDPOINT } from "../../../../../axios/apiConfig";
import { debounce } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import "react-activity/dist/library.css";
import { copyToClipboard } from "../../../../../Utils/CopyContent";
import DragDropModal from "../../../../CommonComponent/DragDropModal";
import { useRef } from "react";

const CommonAddEventModelNew = ({
  show,
  onClose,
  webinarDetail,
  data,
  handleSubmit,
}) => {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

  const globalstreamTypeMap = {
    "One Source": "1",
    1: "1",
    Zoom: "2",
    "Zoom Conference": "2",
    2: "2",
    Webex: "3",
    "Webex Conference": "3",
    3: "3",
    "Third Party": "4",
    4: "4",
    "Third party": "4",
    0: "0",
    "No streaming": "0",
    "No Streaming": "0",
  };

  const timeHours = Array.from({ length: 24 }, (_, i) => ({
    label: i < 10 ? `0${i} ` : `${i} `,
    value: i < 10 ? `0${i}` : `${i}`,
  }));

  const timeMinutes = Array.from({ length: 12 }, (_, i) => ({
    label: i === 0 ? "00" : `${i * 5 < 10 ? "0" + i * 5 : i * 5}`,
    value: i === 0 ? "00" : `${i * 5 < 10 ? "0" + i * 5 : i * 5}`,
  }));

  const [error, setError] = useState({});
  const currentDate = new Date();
  const [countryTimezone, setCountryTimezone] = useState([]);
  const clientStreamOptions = [
    { label: "Yes", value: "1" },
    { label: "No", value: "0" },
  ];
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [originalTimeZoneOptions, setOriginalTimeZoneOptions] = useState([]);
  const [ibuOptions, setIBUOptions] = useState([]);

  const [previousTitle, setPreviousTitle] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedCode, setSelectedCode] = useState(null);

  const [meetingOptions, setMeetingOptions] = useState([
    { label: "Live", value: "Live" },
    { label: "Virtual", value: "Virtual" },
  ]);
  const eventOptions = [
    { label: "Online", value: "Online" },
    { label: "Conference", value: "Conference" },
    { label: "On-Site", value: "On-Site" },
  ];
  const eventStreamingOptions = [
    { label: "No Streaming", value: "No Streaming" },
    { label: "Zoom", value: "Zoom" },
    { label: "Webex", value: "Webex" },
    { label: "One Source", value: "One Source" },
    { label: "Third Party", value: "Third Party" },
  ];
  const streamTypeMap = {
    0: "No Streaming",
    1: "One Source",
    2: "Zoom",
    3: "Webex",
    4: "Third Party",
  };
  const SectionOptions = [
    { label: "Registration", value: "Registration" },
    { label: "Live Stream", value: "Live Stream" },
    { label: "Chat link", value: "Chat" },
    { label: "Polls", value: "Polls" },
  ];

  const [draggedModules, setDraggedModules] = useState({});
  const [titleBlurredOnce, setTitleBlurredOnce] = useState(false);

  const streamingFeatureOptions = [
    {
      label: "Questions window",
      value: "Questions window",
      tooltip:
        "A window in the live stream portal where users can submit questions to the speake",
    },
    {
      label: "Call request",
      value: "Call request",
      tooltip:
        "Allows users to request a call to speak directly with the speaker during the meeting",
    },
    {
      label: "Townhall",
      value: "Townhall",
      tooltip:
        "Let participants watch see each other and invited to speak directly",
    },
  ];

  const userId = localStorage.getItem("user_id");
  const showPostEventSurvey = userId === "iSnEsKu5gB/DRlycxB6G4g==";

  const moduleGroups = {
    "On-Site": [
      {
        id: "preOnSiteEvent",
        title: "Pre-On-site event",
        source: [
          {
            title: "Email engine",
            tooltip:
              "For sending invites and reminders about content and events",
          },
          {
            title: "Registration page",
            tooltip: "Use if you wish HCPs to register",
          },
          {
            title: "Event agenda",
            tooltip: "A set of PDFs, vidoes or both about this event",
          },
          {
            title: "Event content collection",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with during the event",
          },
        ],
        target: [],
      },
      {
        id: "inOnSiteEvent",
        title: "In-On-site event",
        source: [
          {
            title: "AudienceZone",
            tooltip: "Let attendees in location write questions to speakers",
          },
          {
            title: "Q & Polls",
            tooltip: "Run polls during events (online, local and hybrid)",
          },
          // {
          //   "title" : "In-event survey",
          //   "tooltip" : "If you wish the audience to answer a survey while attending",
          // }
        ],
        target: [],
      },
      {
        id: "postOnSiteEvent",
        title: "Post-On-site event",
        source: [
          {
            title: "On-Demand content",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with after the event",
          },
          ...(showPostEventSurvey
            ? [
                {
                  title: "Post-event survey",
                  tooltip:
                    "If you wish the audience to answer a survey after the event",
                },
              ]
            : []),
        ],
        target: [],
      },
    ],
    Conference: [
      {
        id: "preConference",
        title: "Pre-Conference",
        source: [
          {
            title: "Email engine",
            tooltip:
              "For sending invites and reminders about content and events",
          },
          {
            title: "Registration page",
            tooltip: "Use if you wish HCPs to register",
          },
          {
            title: "Promo webpage",
            tooltip:
              "If the event needs a separate small webpage about the event (not registration required)",
          },
          {
            title: "Event agenda",
            tooltip: "A set of PDFs, vidoes or both about this event",
          },
          {
            title: "Event content collection",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with during the event",
          },
        ],
        target: [],
      },
      {
        id: "activeConference",
        title: "In-Conference",
        source: [
          {
            title: "Live Stream",
            tooltip: "If you wish to stream the event to an external audience",
          },
          {
            title: "AudienceZone",
            tooltip: "Let attendees in location write questions to speakers",
          },
          {
            title: "Q & Polls",
            tooltip: "Run polls during events (online, local and hybrid)",
          },
          // {
          //   "title" : "In-event survey",
          //   "tooltip" : "If you wish the audience to answer a survey while attending",
          // }
        ],
        target: [],
      },
      {
        id: "postConference",
        title: "Post-Conference",
        source: [
          {
            title: "On-Demand content",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with after the event",
          },
          ...(showPostEventSurvey
            ? [
                {
                  title: "Post-event survey",
                  tooltip:
                    "If you wish the audience to answer a survey after the event",
                },
              ]
            : []),
        ],
        target: [],
      },
    ],
    Online: [
      {
        id: "preOnlineEvent",
        title: "Pre-Online event",
        source: [
          {
            title: "Email engine",
            tooltip:
              "For sending invites and reminders about content and events",
          },
          {
            title: "Registration page",
            tooltip: "Use if you wish HCPs to register",
          },
          {
            title: "Event agenda",
            tooltip: "A set of PDFs, vidoes or both about this event",
          },
          {
            title: "Event content collection",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with during the event",
          },
        ],
        target: [],
      },
      {
        id: "inOnlineEvent",
        title: "In-Online event",
        source: [
          {
            title: "Live Stream",
            tooltip: "If you wish to stream the event to an external audience",
          },
          {
            title: "AudienceZone",
            tooltip: "Let attendees in location write questions to speakers",
          },
          {
            title: "Q & Polls",
            tooltip: "Run polls during events (online, local and hybrid)",
          },
        ],
        target: [],
      },
      {
        id: "postOnlineEvent",
        title: "Post-Online event",
        source: [
          {
            title: "On-Demand content",
            tooltip:
              "A set of PDFs, videos, etc about the event for users to engage with after the event",
          },
          ...(showPostEventSurvey
            ? [
                {
                  title: "Post-event survey",
                  tooltip:
                    "If you wish the audience to answer a survey after the event",
                },
              ]
            : []),
        ],
        target: [],
      },
    ],
  };

  const ConvertedLanguages = [
    { label: "English ", value: "US" },
    { label: "Japanese ", value: "JP" },
    { label: "German", value: "DE" },
    { label: "French", value: "FR" },
    { label: "Russian", value: "RU" },
    { label: "Portuguese", value: "PT" },
    { label: "Spanish", value: "ES" },
    { label: "Korean", value: "KR" },
  ];

  const PrimaryLanguages = [
    { label: "English ", value: "US" },
    { label: "Japanese ", value: "JP" },
    { label: "German", value: "DE" },
    { label: "French", value: "FR" },
    { label: "Russian", value: "RU" },
    { label: "Portuguese", value: "PT" },
    { label: "Spanish", value: "ES" },
    { label: "Korean", value: "KR" },
  ];

  const [eventInputs, setEventInputs] = useState({
    dateStart: new Date(moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY")),
    dateEnd: new Date(moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY")),
    title: "",
    location: "",
    type: "",
    timezone: "",
    country_timezone: "",
    is_client_stream: "",
    client_stream_url: "",
    dateStartHour: "",
    dateStartMin: "",
    dateEndHour: "",
    dateEndMin: "",
    event_code: "",
    event_type: "",
    stream_type: "",
    description: "",
    speaker_name: [{ speakerName: "" }],
    speaker_email: "",
    meeting_type: "",
    meeting_id: "",
    meeting_pass: "",
    preSectionInclude: [],
    sectionInclude: [],
    postSectionInclude: [],
    streamingFeature: [],
    join_url: "",
    language_interpretation: {
      enable: false,
      interpreters: [{ email: "", languages: [] }],
    },
    streaming_url: "",
  });

  let isMena = localStorage.getItem("user_id") == "z2TunmZQf3QwCsICFTLGGQ==";

  const octalachLikeArray = [
    "iSnEsKu5gB/DRlycxB6G4g==",
    "UbCJcnLM9fe HsRMgX8c1A==",
    "z2TunmZQf3QwCsICFTLGGQ==",
    "wW0geGtDPvig5gF 6KbJrg==",
    "qDgwPdToP05Kgzc g2VjIQ==",
  ];

  const isLikeOctalachAccount = octalachLikeArray.includes(
    localStorage.getItem("user_id"),
  );
  const [resetKey, setResetKey] = useState(0);
  const [open, setOpen] = useState(false);
  const [meetingData, setMeetingData] = useState(false);
  useEffect(() => {
    setIBUOptions(webinarDetail?.ibu);
    let uniqueTimeZone = [];
    let uniqueLabelsSet = [];
    webinarDetail?.timezoneName?.forEach((item) => {
      if (!uniqueLabelsSet?.includes(item?.label)) {
        uniqueLabelsSet?.push(item?.label);
        uniqueTimeZone?.push(item);
      }
    });
    setTimezoneOptions(uniqueTimeZone);
    setOriginalTimeZoneOptions(webinarDetail?.timezoneName);
    if (data?.id) {
      let speaker_name = "";
      let speaker_email = "";
      let meeting_type = "";
      let meeting_pass = "";
      let meeting_id = "";
      let event_type = "";
      let stream_type = "";
      let language_interpretation = "";
      let countryTimeZoneOptions = [];
      let sectionInclude = [];
      let streamingFeature = [];
      let streaming_url = "";
      if (data?.raw_description) {
        let parseData = JSON.parse(data?.raw_description);

        try {
          speaker_name = JSON.parse(parseData?.speaker_name);
        } catch {
          speaker_name = parseData?.speaker_name
            ? [{ speakerName: parseData?.speaker_name }]
            : [{ speakerName: "" }];
        }

        speaker_email = parseData?.speaker_email;
        meeting_type = parseData?.meeting_type;
        meeting_pass = data?.meeting_pass || parseData?.meeting_pass;
        meeting_id = data?.meeting_id || parseData?.meeting_id;
        event_type = parseData?.event_type;
        stream_type = data?.stream_type || parseData?.stream_type;
        language_interpretation = parseData?.language_interpretation;
        streaming_url = data?.streaming_url || parseData?.streaming_url;
        if (event_type === "Webinar") {
          event_type = "Online";
        }
      }

      if (Array.isArray(data?.section_include)) {
        sectionInclude = data?.section_include;
      } else if (typeof data?.section_include === "string") {
        sectionInclude = data?.section_include.split("~"); // Convert back from the joined string
      }

      // streamingFeature
      if (Array.isArray(data?.streaming_features)) {
        streamingFeature = data?.streaming_features;
      } else if (typeof data?.streaming_features === "string") {
        streamingFeature = data?.streaming_features.split("~"); // Convert back from the joined string
      }

      let editData = {};
      const preModules = splitOrSingle(data?.pre_section_include);
      const selectedModules = splitOrSingle(data?.section_include);
      const postModules = splitOrSingle(data?.post_section_include);
      if (event_type == "Online") {
        editData = {
          preOnlineEvent: preModules,
          inOnlineEvent: selectedModules,
          postOnlineEvent: postModules,
        };
      } else if (event_type == "Conference") {
        editData = {
          preConference: preModules,
          activeConference: selectedModules,
          postConference: postModules,
        };
      } else {
        editData = {
          preOnSiteEvent: preModules,
          inOnSiteEvent: selectedModules,
          postOnSiteEvent: postModules,
        };
      }
      setDraggedModules(editData);

      countryTimeZoneOptions = webinarDetail?.timezoneName
        ?.map((item) =>
          item?.label == data?.timezone
            ? { label: item?.value, value: item?.value }
            : null,
        )
        .filter(Boolean);
      setCountryTimezone(countryTimeZoneOptions);
      setEventInputs({
        ...data,
        title: data?.title,
        location: data?.location,
        type: data?.type ? data?.type : "",
        timezone: data?.timezone,
        country_timezone: data?.country_timezone,
        is_client_stream: data?.is_client_stream == 1 ? "Yes" : "No",
        client_stream_url: data?.client_stream_url
          ? data?.client_stream_url
          : "",
        dateStart: data?.dateStart,
        dateEnd: data?.dateEnd,
        dateStartHour: data?.dateStartHour ? data?.dateStartHour : "",
        dateStartMin: data?.dateStartMin ? data?.dateStartMin : "",
        dateEndHour: data?.dateEndHour ? data?.dateEndHour : "",
        dateEndMin: data?.dateEndMin ? data?.dateEndMin : "",
        event_code: data?.event_code,
        event_type: event_type === "Webinar" ? "Online" : event_type,
        stream_type: stream_type,
        description: data?.description ? data?.description : "",
        // speaker_name: JSON.parse(speaker_name),
        speaker_name: speaker_name,
        speaker_email: speaker_email,
        meeting_type: meeting_type,
        meeting_id: meeting_id,
        meeting_pass: meeting_pass,
        preSectionInclude: preModules,
        sectionInclude: sectionInclude,
        postSectionInclude: postModules,
        streamingFeature: streamingFeature,
        language_interpretation: language_interpretation,
        streaming_url: streaming_url,
      });

      handleTitleBlur(data?.title, data?.event_code);
    } else {
      setCountryTimezone([]);
      setDraggedModules({});
      setEventInputs({
        dateStart: new Date(
          moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY"),
        ),
        dateEnd: new Date(
          moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY"),
        ),
        title: "",
        location: "",
        type: "",
        timezone: "",
        country_timezone: "",
        is_client_stream: "",
        client_stream_url: "",
        dateStartHour: "",
        dateStartMin: "",
        dateEndHour: "",
        dateEndMin: "",
        event_code: "",
        event_type: "",
        stream_type: "",
        description: "",
        speaker_name: [{ speakerName: "" }],
        speaker_email: "",
        meeting_type: "",
        meeting_pass: "",
        meeting_id: "",
        preSectionInclude: [],
        sectionInclude: [],
        postSectionInclude: [],
        streamingFeature: [],
        streaming_url: "",
      });
      setSuggestions([]);
      setPreviousTitle("");
      setTitleBlurredOnce(false);
    }
  }, [show]);

  const handleClose = () => {
    setError({});
    setEventInputs({
      dateStart: new Date(
        moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY"),
      ),
      dateEnd: new Date(moment(new Date(), "MM/DD/YYYY").format("MM/DD/YYYY")),
      speaker_name: [{ speakerName: "" }],
    });
    onClose(false);
  };
  const debounceTimeoutRef = useRef(null);

  const splitOrSingle = (str) =>
    str?.includes("~") ? str.split("~") : str ? str : [];

  const handleChange = (e, isSelectedName, index) => {
    const { name, value } = e?.target || {};

    if (isSelectedName === "speaker_name") {
      let updateOption = [...eventInputs?.speaker_name];
      updateOption[index].speakerName = value;

      if (
        error?.speaker_name &&
        error?.index === index &&
        value.trim() !== ""
      ) {
        setError((prev) => ({ ...prev, speaker_name: "", index: undefined }));
      }

      setEventInputs({ ...eventInputs, speaker_name: updateOption });
    } else if (name === "event_code") {
      setEventInputs({
        ...eventInputs,
        [isSelectedName || name]: isSelectedName ? e : value?.trim(),
      });
      setError({ ...error, event_code: "" });
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(() => {
        if (value.length > 2) {
          handleDebouncedChange(value);
        }
      }, 500);
    } else if (isSelectedName == "timezone") {
      let countryTimeZoneOptions = originalTimeZoneOptions
        ?.map((item) =>
          item?.label == e?.label
            ? { label: item?.value, value: item?.value }
            : null,
        )
        .filter(Boolean);
      setCountryTimezone(countryTimeZoneOptions);
      setEventInputs({ ...eventInputs, timezone: e?.label });
    } else if (isSelectedName === "sectionInclude") {
      const { value, checked } = e.target;
      setEventInputs((prev) => {
        const currentValues = prev.sectionInclude || [];

        if (value === "Polls") {
          const hasRequiredSelection =
            currentValues.includes("Live Stream") ||
            currentValues.includes("Chat");

          if (!hasRequiredSelection) {
            setError((prev) => ({
              ...prev,
              sectionInclude:
                "Select Chat or Live Stream first to enable Polls.",
            }));
            return prev;
          }
        }

        setError((prev) => ({ ...prev, sectionInclude: "" }));
        return {
          ...prev,
          sectionInclude: checked
            ? [...currentValues, value]
            : currentValues.filter((item) => item !== value),
        };
      });
    } else if (isSelectedName === "streamingFeature") {
      const { value, checked } = e.target;
      setEventInputs((prev) => {
        const currentValues = prev.streamingFeature || [];
        return {
          ...prev,
          streamingFeature: checked
            ? [...currentValues, value]
            : currentValues.filter((item) => item !== value),
        };
      });
    } else if (isSelectedName === "stream_type") {
      const newStreamType = e;
      setEventInputs((prev) => {
        let updatedSectionInclude = [...(prev.sectionInclude || [])];

        if (
          ["Zoom", "Webex", "Third Party", "One Source"].includes(newStreamType)
        ) {
          if (!updatedSectionInclude.includes("Live Stream")) {
            updatedSectionInclude.push("Live Stream");
          }
        } else {
          updatedSectionInclude = updatedSectionInclude.filter(
            (item) => item !== "Live Stream",
          );
        }
        return {
          ...prev,
          stream_type: newStreamType,
          meeting_id: "",
          meeting_pass: "",
          streaming_url: "",
          sectionInclude: updatedSectionInclude,
        };
      });
      setError((prev) => ({ ...prev, stream_type: "" }));
    } else if (isSelectedName === "streaming_url") {
      setEventInputs({ ...eventInputs, streaming_url: e || [] });
    } else if (isSelectedName === "interpretation") {
      setEventInputs({
        ...eventInputs,
        language_interpretation: {
          enable: e,
          interpreters: e ? [{ email: "", languages: "US," }] : [],
        },
      });

      if (!e) {
        setError((prev) => {
          let newErrors = { ...prev };
          Object.keys(newErrors).forEach((key) => {
            if (
              key.startsWith("interpreterEmail") ||
              key.startsWith("primaryLanguage") ||
              key.startsWith("convertedLanguage")
            ) {
              delete newErrors[key];
            }
          });
          return newErrors;
        });
      }
    } else if (isSelectedName === "interpreterEmail") {
      setEventInputs((prev) => {
        let updatedInterpreters = [
          ...(prev.language_interpretation?.interpreters || []),
        ];
        updatedInterpreters[index] = {
          ...updatedInterpreters[index],
          email: value,
        };
        return {
          ...prev,
          language_interpretation: {
            ...prev.language_interpretation,
            interpreters: updatedInterpreters,
          },
        };
      });

      setError((prev) => ({ ...prev, [`interpreterEmail${index}`]: "" }));
    } else if (isSelectedName === "convertedLanguage") {
      setEventInputs((prev) => {
        let updatedInterpreters = [
          ...(prev.language_interpretation?.interpreters || []),
        ];
        updatedInterpreters[index] = {
          ...updatedInterpreters[index],
          languages: `${
            updatedInterpreters[index].languages?.split(",")[0] || ""
          },${e?.value || ""}`,
        };
        return {
          ...prev,
          language_interpretation: {
            ...prev.language_interpretation,
            interpreters: updatedInterpreters,
          },
        };
      });
      setError((prev) => ({ ...prev, [`convertedLanguage${index}`]: "" }));
    } else if (isSelectedName === "primaryLanguage") {
      setEventInputs((prev) => {
        let updatedInterpreters = [
          ...(prev.language_interpretation?.interpreters || []),
        ];

        let currentLanguages = updatedInterpreters[index]?.languages || "";
        let [primary, secondary] = currentLanguages.split(",");

        primary = e?.value || primary;

        updatedInterpreters[index] = {
          ...updatedInterpreters[index],
          languages: [primary, secondary].filter(Boolean).join(","),
        };

        return {
          ...prev,
          language_interpretation: {
            ...prev.language_interpretation,
            interpreters: updatedInterpreters,
          },
        };
      });

      setError((prev) => ({ ...prev, [`primaryLanguage${index}`]: "" }));
    } else if (isSelectedName === "event_type") {
      if (e === "Webinar") {
        e = "Online";
      }
      if (eventInputs?.event_type != e) {
        setEventInputs({
          ...eventInputs,
          stream_type: "",
          streamingFeature: "",
          preSectionInclude: "",
          sectionInclude: "",
          postSectionInclude: "",
          [isSelectedName || name]: isSelectedName ? e : value,
        });
        setDraggedModules({});
        handleReset();
      } else {
        const updatedInputs = {
          ...eventInputs,
          [isSelectedName || name]: isSelectedName ? e : value,
        };

        if (isSelectedName === "dateStart") {
          updatedInputs.dateEnd = isSelectedName ? e : value;
        }
        setEventInputs(updatedInputs);
      }
    } else {
      const updatedInputs = {
        ...eventInputs,
        [isSelectedName || name]: isSelectedName ? e : value,
      };

      if (isSelectedName === "dateStart") {
        updatedInputs.dateEnd = isSelectedName ? e : value;
      }
      setEventInputs(updatedInputs);
    }
  };

  const handleDebouncedChange = async (value) => {
    try {
      let err = "";
      let eventCode = value;
      const response = await postData(ENDPOINT.EVENT_ID, { eventCode });

      if (response?.data?.data?.id) {
        if (data?.id !== response?.data?.data?.id) {
          err = "Event code already exists";
          setError((prevError) => ({ ...prevError, event_code: err }));
          return;
        }
      } else {
        setError((prevError) => ({ ...prevError, event_code: err }));
      }
    } catch (err) {
      console.log("--err", err);
    }
  };

  const addNewSpeakerClicked = (e, isSelectedName) => {
    let speakerObj = {
      speakerName: "",
    };
    let error = {};
    if (eventInputs?.speaker_name?.length) {
      let index = eventInputs?.speaker_name?.findIndex(
        (data, index) => data?.speakerName == "",
      );
      if (index > -1) {
        // toast.error(`Please fill the speaker name ${index + 1}`);
        error = { speaker_name: "Please enter speaker name", index: index };
        setError(error);
        return;
      } else {
        setEventInputs({
          ...eventInputs,
          speaker_name: [...eventInputs?.speaker_name, speakerObj],
        });
      }
    }
  };

  const checkInterpretatorError = (source = "add") => {
    let errors = {}; // Store all errors

    // Check empty email
    eventInputs.language_interpretation?.interpreters?.forEach(
      (data, index) => {
        if (data.email === "") {
          errors[`interpreterEmail${index}`] =
            source == "save"
              ? "Interpreter email is required"
              : "Enter interpreter email";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
          errors[`interpreterEmail${index}`] =
            source == "save"
              ? "Interpreter email is invalid"
              : "Email is invalid";
        }
      },
    );

    // Check duplicate emails
    let emailSet = new Set();
    eventInputs.language_interpretation?.interpreters?.forEach(
      (data, index) => {
        if (data.email && emailSet.has(data.email)) {
          errors[`interpreterEmail${index}`] = "Enter different email";
        }
        emailSet.add(data.email);
      },
    );

    // Check empty language fields and duplicate languages
    eventInputs.language_interpretation?.interpreters?.forEach(
      (data, index) => {
        let languages = data.languages?.split(",") || [];

        if (languages.length < 2 || languages[1].trim() === "") {
          errors[`convertedLanguage${index}`] = "Select language";
        } else if (languages[0].trim() === languages[1].trim()) {
          errors[`convertedLanguage${index}`] = "Select different language";
        }
      },
    );

    // If there are errors, set them in state and return false
    if (Object.keys(errors).length > 0) {
      setError((prev) => ({ ...prev, ...errors }));
      return false;
    }

    return true;
  };

  const addNewInterpretator = () => {
    let newInterpreter = { email: "", languages: "US" };
    const emptyEmailIndex = checkInterpretatorError();
    if (!emptyEmailIndex) {
      return;
    }
    // Add a new interpreter and clear any existing errors
    setEventInputs((prev) => ({
      ...prev,
      language_interpretation: {
        enable: true,
        interpreters: [
          ...(prev.language_interpretation?.interpreters || []),
          newInterpreter,
        ],
      },
    }));

    setError((prev) => {
      const newErrors = { ...prev };
      delete newErrors[`interpreterEmail${emptyEmailIndex}`]; // Remove error when email is added
      return newErrors;
    });
  };

  const deleteInterpretator = (e, index) => {
    e.preventDefault();
    let updatedInterpreters = [
      ...(eventInputs.language_interpretation?.interpreters || []),
    ];

    if (updatedInterpreters.length > 1) {
      updatedInterpreters.splice(index, 1);

      setEventInputs((prev) => ({
        ...prev,
        language_interpretation: {
          ...prev.language_interpretation,
          interpreters: updatedInterpreters,
        },
      }));

      // Remove only the deleted interpreter's error
      setError((prev) => {
        const newErrors = { ...prev };

        // Remove the error of the deleted field
        delete newErrors[`interpreterEmail${index}`];
        delete newErrors[`convertedLanguage${index}`];

        // Reassign errors for shifted indexes
        let updatedErrors = {};
        Object.keys(newErrors).forEach((key) => {
          const match = key.match(/^interpreterEmail(\d+)$/);
          if (match) {
            let oldIndex = parseInt(match[1], 10);
            let newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
            updatedErrors[`interpreterEmail${newIndex}`] = newErrors[key];
          } else {
            updatedErrors[key] = newErrors[key];
          }
        });

        return updatedErrors;
      });
    } else {
      setError((prev) => ({
        ...prev,
        [`interpreterEmail${index}`]:
          "At least one Interpreter must be required",
      }));
    }
  };

  const deleteSpeaker = (e, index) => {
    e.preventDefault();
    let error = {};
    if (Object.keys(eventInputs?.speaker_name)?.length > 1) {
      let updatedEventInputs = eventInputs?.speaker_name;
      updatedEventInputs?.splice(index, 1);
      setEventInputs({ ...eventInputs, speaker_name: updatedEventInputs });
      setError();
    } else {
      error = {
        speaker_name: "Atleast one Speaker must be required",
        index: index,
      };
      setError(error);
      return;
    }
  };

  const formatDate = (newDate) => {
    if (newDate != "") {
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    }
  };

  function isValidDateFormat(dateString) {
    const regex = /^\d{1,2} [A-Za-z]+ \d{4}$/;
    return regex.test(dateString);
  }

  function convertDate(dateString) {
    const formattedDate = moment(dateString, "DD MMMM YYYY").format(
      "YYYY-MM-DD",
    );
    return formattedDate;
  }

  const saveClicked = async () => {
    try {
      // if (error?.event_code) return;
      const errorSaveClicked = EventModelValidationNew(eventInputs);
      let isError = false;
      if (Object.keys(errorSaveClicked).length) {
        setError(errorSaveClicked);
        isError = true;
      }

      if (
        eventInputs?.streaming_url &&
        !/^https?:\/\//.test(eventInputs.streaming_url)
      ) {
        setError((prev) => ({
          ...prev,
          streaming_url: "Streaming URL should start with 'http' or 'https'",
        }));
        isError = true;
      } else {
        setError((prev) => {
          let newErrors = { ...prev };
          delete newErrors.streaming_url;
          return newErrors;
        });
      }

      const emptyEmailIndex = checkInterpretatorError("save");
      if (!emptyEmailIndex) {
        isError = true;
      }

      // New validation for polls
      const hasPolls = eventInputs.sectionInclude.includes("Polls");
      const hasLiveStreamOrChat =
        eventInputs.sectionInclude.includes("Live Stream") ||
        eventInputs.sectionInclude.includes("Chat");

      if (hasPolls && !hasLiveStreamOrChat) {
        setError((prev) => ({
          ...prev,
          sectionInclude: "Select Chat or Live Stream first to enable Polls.",
        }));
        isError = true;
      }

      if (isError) {
        console.log(isError, "streamingFeature", error);
        return;
      }

      loader("show");

      const formatEventDate = (date) =>
        isValidDateFormat(date)
          ? convertDate(date)
          : formatDate(new Date(date));

      const {
        title,
        location,
        type = "",
        event_type = "",
        stream_type,
        timezone,
        country_timezone,
        is_client_stream,
        client_stream_url = "",
        dateStart,
        dateEnd,
        dateStartHour,
        dateStartMin,
        dateEndHour,
        dateEndMin,
        event_code,
        description = "",
        speaker_name,
        speaker_email = "",
        meeting_type = "",
        meeting_id = "",
        meeting_pass = "",
        preSectionInclude = [],
        sectionInclude = [],
        postSectionInclude = [],
        streamingFeature = [],
        language_interpretation = {},
        join_url = "",
        streaming_url = "",
      } = eventInputs;

      let dataObj = {
        title,
        location,
        type,
        event_type,
        stream_type: globalstreamTypeMap[stream_type] || "0",
        timezone,
        countryTimezone: country_timezone,
        isClientStream: is_client_stream === "Yes" ? 1 : 0,
        clientStreamUrl: client_stream_url,
        dateStart: formatEventDate(dateStart),
        dateEnd: formatEventDate(dateEnd),
        dateStartHour,
        dateStartMin,
        dateEndHour,
        dateEndMin,
        eventCode: event_code,
        description,
        speaker_name: speaker_name ? JSON.stringify(speaker_name) : "",
        speaker_email,
        meeting_type,
        meeting_id,
        meeting_pass,
        join_url,
        preSectionInclude: preSectionInclude.length
          ? preSectionInclude.join("~")
          : "",
        sectionInclude: sectionInclude.length ? sectionInclude.join("~") : "",
        postSectionInclude: postSectionInclude.length
          ? postSectionInclude.join("~")
          : "",
        streamingFeature: streamingFeature.length
          ? streamingFeature.join("~")
          : "",

        language_interpretation: {
          enable: eventInputs.language_interpretation?.enable || false,
          interpreters: eventInputs.language_interpretation?.interpreters || [],
        },
        streaming_url: streaming_url,
      };
      // console.log(dataObj,'dataObj');
      if (data?.id) {
        const {
          meeting_type,
          meeting_id,
          meeting_pass,
          join_url,
          ...filteredDataObj
        } = dataObj;

        const isStreamTypeChanged = stream_type !== data?.stream_type;
        const shouldRegenerateCredentials =
          !data?.meeting_id || !data?.meeting_pass || isStreamTypeChanged;

        if (shouldRegenerateCredentials) {
          if (["Zoom", "2", 2].includes(stream_type)) {
            const { data: meetingResponse } = await fetchDataForWebinar(
              ENDPOINT.ZOOM_MEETING_CREATE,
              "POST",
              filteredDataObj,
            );
            if (meetingResponse?.status === 200) {
              dataObj.meeting_id = meetingResponse.data.meeting_id;
              dataObj.meeting_pass = meetingResponse.data.passcode;
              dataObj.join_url = meetingResponse.data.join_url;
              setMeetingData(meetingResponse.data);
            }
          }
        } else if (["Zoom", "2", 2].includes(stream_type)) {
          const { data: meetingResponse } = await fetchDataForWebinar(
            `${ENDPOINT.MEETING_UPDATE}/${data?.meeting_id}`,
            "PATCH",
            dataObj,
          );
          if (meetingResponse?.status === 200) {
            dataObj.meeting_id = meetingResponse.data.meeting_id;
            dataObj.meeting_pass = meetingResponse.data.passcode;
            dataObj.join_url = meetingResponse.data.join_url;
            setMeetingData(meetingResponse.data);
          }
        }

        await updateConsent(
          `${ENDPOINT.WEBINAR_UPDATE_EVENT}/${data?.id}`,
          dataObj,
        );
      } else {
        const { meeting_type, meeting_id, meeting_pass, ...filteredDataObj } =
          dataObj;

        if (["Zoom", "2", 2].includes(stream_type)) {
          const { data: meetingResponse } = await fetchDataForWebinar(
            ENDPOINT.ZOOM_MEETING_CREATE,
            "POST",
            filteredDataObj,
          );

          if (meetingResponse.status === 200) {
            dataObj.meeting_id = meetingResponse.data.meeting_id;
            dataObj.meeting_pass = meetingResponse.data.passcode;
            dataObj.join_url = meetingResponse.data.join_url;
            setMeetingData(meetingResponse.data);
          }
        }

        await postData(ENDPOINT.WEBINAR_ADD_NEW_EVENT, dataObj);

        // setOpen(
        //   !["No Streaming", 0,"0",3,"3","Webex Conference","Webex",4,"4","Other","One Source",1,"1"].includes(stream_type)
        // );
        setOpen([2, "2", "Zoom", "Zoom Confrence"].includes(stream_type));
      }

      setEventInputs({
        dateStart: new Date(moment().format("MM/DD/YYYY")),
        dateEnd: new Date(moment().format("MM/DD/YYYY")),
        speaker_name: [{ speakerName: "" }],
      });

      handleSubmit();
      setError({});
    } catch (err) {
      console.error("Error:", err);
      if (err?.response?.data?.message === "Event code already exist") {
        setError({ event_code: err.response.data.message });
      }
    } finally {
      loader("hide");
    }
  };

  const getFilteredStreamingOptions = () => {
    let options = eventStreamingOptions.filter(
      (option) => option.value !== "One Source" || isLikeOctalachAccount,
    );

    if (
      draggedModules?.activeConference?.includes("Live Stream") ||
      draggedModules?.inOnlineEvent?.includes("Live Stream")
    ) {
      options = options.filter((option) => option.value !== "No Streaming");
    }

    if (eventInputs?.event_type === "Conference") {
      options = options.filter(
        (option) =>
          option.value !== "Third Party" && option.value !== "One Source",
      );
    } else if (eventInputs?.event_type === "On-Site") {
      options = options.filter(
        (option) =>
          option.value !== "Third Party" &&
          option.value !== "One Source" &&
          option.value !== "Zoom" &&
          option.value !== "Webex",
      );
    }
    return options.map((option) => {
      if (option.value === "Zoom" || option.value === "Webex") {
        return {
          ...option,
          label:
            eventInputs?.event_type === "Conference"
              ? `${option.label} Conference`
              : option.label,
        };
      }
      return option;
    });
  };

  function LinkWithTooltip({ id, children, href, tooltip }) {
    return (
      <OverlayTrigger
        overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <a href={href}>{children}</a>
      </OverlayTrigger>
    );
  }
  const handleBlur = (index) => {
    const email =
      eventInputs.language_interpretation?.interpreters[index]?.email?.trim() ||
      "";
    const existingEmails =
      eventInputs.language_interpretation?.interpreters.map((data) =>
        data.email?.trim(),
      );

    // Email validation
    if (!email) {
      setError((prev) => ({
        ...prev,
        [`interpreterEmail${index}`]: "Email is required",
      }));
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError((prev) => ({
        ...prev,
        [`interpreterEmail${index}`]: "Invalid email format",
      }));
    } else if (existingEmails.filter((e) => e === email).length > 1) {
      setError((prev) => ({
        ...prev,
        [`interpreterEmail${index}`]: "Please enter different email",
      }));
    } else {
      setError((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`interpreterEmail${index}`];
        return newErrors;
      });
    }

    // Language validation
    // const primaryLang =
    //   eventInputs.language_interpretation?.interpreters[
    //     index
    //   ]?.languages?.split(",")[0] || "";
    // const convertedLang =
    //   eventInputs.language_interpretation?.interpreters[
    //     index
    //   ]?.languages?.split(",")[1] || "";

    // if (primaryLang && convertedLang && primaryLang === convertedLang) {
    //   setError((prevError) => ({
    //     ...prevError,
    //     [`primaryLanguage${index}`]: "Please select different language",
    //     [`convertedLanguage${index}`]: "",
    //   }));
    // } else {
    //   setError((prevError) => {
    //     const newErrors = { ...prevError };
    //     delete newErrors[`primaryLanguage${index}`];
    //     delete newErrors[`convertedLanguage${index}`];
    //     return newErrors;
    //   });
    // }
  };

  const cancelPopup = () => {
    setOpen(false);
  };

  const handleTitleBlur = async (title, event_code = null) => {
    if (!title || title === previousTitle) return;
    setPreviousTitle(title);
    try {
      const response = await postData(ENDPOINT.DYNAMIC_EVENT_CODE, {
        eventTitle: title,
      });
      const suggestions = response?.data?.data?.suggestions || [];
      setSuggestions(
        event_code ? [...new Set([event_code, ...suggestions])] : suggestions,
      );
      setTitleBlurredOnce(true);
    } catch (err) {
      console.log("--err", err);
    }
  };

  const handleSuggestionSelect = (selectedCode) => {
    handleChange({ target: { name: "event_code", value: selectedCode } });
  };

  const handleDragDropDataUpdate = (data) => {
    setDraggedModules(data);
  };

  const handleReset = () => {
    setResetKey((prev) => prev + 1);
  };

  useEffect(() => {
    let pre = [];
    let mid = [];
    let post = [];

    switch (eventInputs.event_type) {
      case "On-Site":
        pre = draggedModules?.preOnSiteEvent || [];
        mid = draggedModules?.inOnSiteEvent || [];
        post = draggedModules?.postOnSiteEvent || [];
        break;

      case "Online":
        pre = draggedModules?.preOnlineEvent || [];
        mid = draggedModules?.inOnlineEvent || [];
        post = draggedModules?.postOnlineEvent || [];
        break;

      case "Conference":
        pre = draggedModules?.preConference || [];
        mid = draggedModules?.activeConference || [];
        post = draggedModules?.postConference || [];
        break;

      default:
        pre = [];
        mid = [];
        post = [];
    }

    if (!mid?.includes("Live Stream")) {
      setEventInputs((prev) => ({
        ...prev,
        preSectionInclude: pre,
        sectionInclude: mid,
        postSectionInclude: post,
        stream_type: "",
      }));
    } else {
      setEventInputs((prev) => ({
        ...prev,
        preSectionInclude: pre,
        sectionInclude: mid,
        postSectionInclude: post,
      }));
    }
  }, [
    draggedModules?.preOnSiteEvent,
    draggedModules?.inOnSiteEvent,
    draggedModules?.postOnSiteEvent,
    draggedModules?.preOnlineEvent,
    draggedModules?.inOnlineEvent,
    draggedModules?.postOnlineEvent,
    draggedModules?.preConference,
    draggedModules?.activeConference,
    draggedModules?.postConference,
    eventInputs.event_type,
  ]);

  const filteredStreamingOptions = streamingFeatureOptions.filter((option) => {
    if (eventInputs?.event_type === "Conference") {
      return (
        option.value === "Questions window" || option.value === "Call request"
      );
    } else if (eventInputs?.event_type === "Online") {
      return option.value === "Questions window" || option.value === "Townhall";
    }
    return true;
  });

  // useEffect(() => {
  //   if (eventInputs?.event_type === "Conference") {
  //     setEventInputs((prev) => ({
  //       ...prev,
  //       streamingFeature: (prev.streamingFeature || []).filter(
  //         (feature) => feature === "Questions window"
  //       ),
  //     }));
  //   }
  // }, [eventInputs?.event_type]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        id="add_hcp"
        className="event_edit"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Header>
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              {data?.id ? "Edit Event" : "Create New Event"}
            </h5>
            <button
              type="button"
              onClick={handleClose}
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="hcp-add-box custom-change">
              <div className="hcp-add-form tab-content" id="upload-confirm">
                <form id="add_hcp_form" className={"tab-pane" + "active"}>
                  <>
                    <div className="add_hcp_boxes create-change-content">
                      <div className="form_action">
                        <h4>Event Details</h4>
                        <Row>
                          <Col md={12}>
                            <div className="form-group d-flex align-items-center full-width">
                              <label htmlFor="">
                                Event Title <span> *</span>
                              </label>
                              <input
                                type="text"
                                name="title"
                                placeholder="Event title"
                                className={
                                  error?.title
                                    ? "form-control error"
                                    : "form-control"
                                }
                                onChange={(e) => handleChange(e)}
                                onBlur={() =>
                                  handleTitleBlur(eventInputs?.title)
                                }
                                value={
                                  eventInputs?.title ? eventInputs?.title : ""
                                }
                              />
                              {error?.title ? (
                                <div className="login-validation">
                                  {error?.title}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={12} className="speaker-name">
                            <div className="multi-speaker-add">
                              {/* {Object.keys(eventInputs?.speaker_name)?.map((item, index) => ( */}

                              <div className="form-group d-flex align-items-center">
                                {/* {index === 0 ? ( */}
                                <label htmlFor="">
                                  Speaker's name <span>*</span>
                                </label>
                                {/* ) : ( */}
                                {/* "" */}
                                {/* )} */}

                                <div className="speaker-number">
                                  {Object.keys(eventInputs?.speaker_name)?.map(
                                    (item, index) => (
                                      <>
                                        <div className="speaker-number-box d-flex align-items-center mb-4">
                                          <div className="count-number">
                                            {index + 1}.
                                          </div>

                                          <input
                                            type="text"
                                            name="speaker_name"
                                            placeholder="Speaker's name"
                                            className={
                                              error?.speaker_name &&
                                              error?.index == index
                                                ? "form-control error"
                                                : "form-control"
                                            }
                                            onChange={(e) =>
                                              handleChange(
                                                e,
                                                "speaker_name",
                                                index,
                                              )
                                            }
                                            value={
                                              eventInputs?.speaker_name[item]
                                                ?.speakerName
                                            }
                                          />

                                          {Object.keys(
                                            eventInputs?.speaker_name,
                                          )?.length > 1 && (
                                            <button
                                              onClick={(e) => {
                                                deleteSpeaker(e, index);
                                              }}
                                            >
                                              <img
                                                src={
                                                  path_image + "delete-icon.svg"
                                                }
                                                alt=""
                                              />
                                            </button>
                                          )}
                                        </div>
                                        {error?.speaker_name &&
                                          error?.index == index && (
                                            <div className="login-validation">
                                              {error?.speaker_name}
                                            </div>
                                          )}
                                      </>
                                    ),
                                  )}
                                  <span
                                    className="add-choice"
                                    onClick={(e) =>
                                      addNewSpeakerClicked(e, "speaker")
                                    }
                                  >
                                    Add speaker
                                    <img
                                      src={
                                        path_image + "add-choice-voilet-new.svg"
                                      }
                                      alt=""
                                    />
                                  </span>
                                </div>

                                {/* {error?.speaker_name && error?.index == index && (
                                    <div className="login-validation">{error?.speaker_name}</div>
                                  )} */}
                              </div>
                              {/* ))} */}
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group d-flex align-items-center">
                              <label htmlFor="">
                                Location <span> *</span>{" "}
                                <LinkWithTooltip tooltip="The physical or virtual location where the event will take place">
                                  <img
                                    src={path_image + "info_circle_icon.svg"}
                                    alt="tooltip-btn"
                                  />
                                </LinkWithTooltip>
                              </label>
                              <input
                                type="text"
                                name="location"
                                placeholder="Event location"
                                className={
                                  error?.location
                                    ? "form-control error"
                                    : "form-control"
                                }
                                onChange={(e) => handleChange(e)}
                                value={
                                  eventInputs?.location
                                    ? eventInputs?.location
                                    : ""
                                }
                              />
                              {error?.location ? (
                                <div className="login-validation">
                                  {error?.location}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group d-flex align-items-center">
                              <label htmlFor="">
                                {" "}
                                Timezone <span> *</span>{" "}
                                <LinkWithTooltip tooltip="The specific timezone the event will follow for its scheduled time">
                                  <img
                                    src={path_image + "info_circle_icon.svg"}
                                    alt="tooltip-btn"
                                  />
                                </LinkWithTooltip>
                              </label>
                              <Select
                                options={timezoneOptions}
                                className={
                                  error?.timezone
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                onChange={(e) => handleChange(e, "timezone")}
                                placeholder="Select timezone"
                                value={
                                  timezoneOptions
                                    ? timezoneOptions?.findIndex(
                                        (item) =>
                                          item?.label == eventInputs?.timezone,
                                      ) != -1
                                      ? timezoneOptions[
                                          timezoneOptions?.findIndex(
                                            (item) =>
                                              item?.label ==
                                              eventInputs?.timezone,
                                          )
                                        ]
                                      : ""
                                    : ""
                                }
                                isClearable
                              />
                              {error?.timezone ? (
                                <div className="login-validation">
                                  {error?.timezone}
                                </div>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="form-group align-items-center">
                              <label htmlFor="">
                                Country Timezone <span> *</span>{" "}
                                <LinkWithTooltip tooltip="The country associated with the selected timezone">
                                  <img
                                    src={path_image + "info_circle_icon.svg"}
                                    alt="tooltip-btn"
                                  />
                                </LinkWithTooltip>
                              </label>
                              <Select
                                options={countryTimezone}
                                className={
                                  error?.country_timezone
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                onChange={(e) =>
                                  handleChange(e?.value, "country_timezone")
                                }
                                placeholder="Select country timezone"
                                value={
                                  countryTimezone
                                    ? countryTimezone?.findIndex(
                                        (item) =>
                                          item?.value ==
                                          eventInputs?.country_timezone,
                                      ) != -1
                                      ? countryTimezone[
                                          countryTimezone?.findIndex(
                                            (item) =>
                                              item?.value ==
                                              eventInputs?.country_timezone,
                                          )
                                        ]
                                      : ""
                                    : ""
                                }
                                isClearable
                              />
                              {error?.country_timezone ? (
                                <div className="login-validation">
                                  {error?.country_timezone}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group d-flex align-items-center event-date">
                              <label htmlFor="">
                                Event Start Date <span> *</span>
                              </label>

                              <DatePicker
                                name="dateStart"
                                className={
                                  error?.dateStart
                                    ? "form-control error"
                                    : "form-control"
                                }
                                placeholderText="Event date"
                                selected={
                                  eventInputs?.dateStart
                                    ? new Date(eventInputs?.dateStart)
                                    : new Date(
                                        moment(new Date(), "MM/DD/YYYY").format(
                                          "MM/DD/YYYY",
                                        ),
                                      )
                                }
                                onChange={(date) =>
                                  handleChange(date, "dateStart")
                                }
                                minDate={currentDate}
                                dateFormat="dd/MM/yyyy"
                              />
                              <span className="date-picker-symbol">&</span>
                              <span className="date-picker-time">Time</span>
                              <Select
                                options={timeHours}
                                className={
                                  error?.dateStartHour
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                onChange={(e) =>
                                  handleChange(e?.value, "dateStartHour")
                                }
                                placeholder="Hour"
                                value={
                                  timeHours?.findIndex(
                                    (item) =>
                                      item?.value == eventInputs?.dateStartHour,
                                  ) != -1
                                    ? timeHours[
                                        timeHours?.findIndex(
                                          (item) =>
                                            item?.value ==
                                            eventInputs?.dateStartHour,
                                        )
                                      ]
                                    : // : timeHours[0]
                                      null
                                }
                                isClearable
                              />
                              <span className="date-picker-symbol1">:</span>
                              <Select
                                options={timeMinutes}
                                className={
                                  error?.dateStartHour
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                onChange={(e) =>
                                  handleChange(e?.value, "dateStartMin")
                                }
                                placeholder="Min"
                                value={
                                  timeMinutes?.findIndex(
                                    (item) =>
                                      item?.value == eventInputs?.dateStartMin,
                                  ) != -1
                                    ? timeMinutes[
                                        timeMinutes?.findIndex(
                                          (item) =>
                                            item?.value ==
                                            eventInputs?.dateStartMin,
                                        )
                                      ]
                                    : // : timeMinutes[0]
                                      null
                                }
                                isClearable
                              />
                              {error?.dateStartHour ? (
                                <div className="login-validation">
                                  {error?.dateStartHour}
                                </div>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="form-group d-flex align-items-center event-date">
                              <label htmlFor="">
                                Event End Date <span> *</span>
                              </label>
                              <DatePicker
                                name="dateEnd"
                                className={
                                  error?.dateEnd
                                    ? "form-control error"
                                    : "form-control"
                                }
                                placeholderText="Event date"
                                selected={
                                  eventInputs?.dateEnd
                                    ? new Date(eventInputs?.dateEnd)
                                    : new Date(
                                        moment(new Date(), "MM/DD/YYYY").format(
                                          "MM/DD/YYYY",
                                        ),
                                      )
                                }
                                onChange={(date) =>
                                  handleChange(date, "dateEnd")
                                }
                                minDate={eventInputs.dateStart || currentDate}
                                dateFormat="dd/MM/yyyy"
                              />{" "}
                              <span className="date-picker-symbol">&</span>
                              <span className="date-picker-time">Time</span>
                              <Select
                                options={timeHours}
                                className={
                                  error?.dateEndHour
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                placeholder="Hour"
                                onChange={(e) =>
                                  handleChange(e?.value, "dateEndHour")
                                }
                                value={
                                  timeHours?.findIndex(
                                    (item) =>
                                      item?.value == eventInputs?.dateEndHour,
                                  ) != -1
                                    ? timeHours[
                                        timeHours?.findIndex(
                                          (item) =>
                                            item?.value ==
                                            eventInputs?.dateEndHour,
                                        )
                                      ]
                                    : // : timeHours[0]
                                      null
                                }
                                isClearable
                              />
                              <span className="date-picker-symbol1">:</span>
                              <Select
                                options={timeMinutes}
                                // className="dropdown-basic-button split-button-dropup edit-country-dropdown"
                                className={
                                  error?.dateEndHour
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                placeholder="Min"
                                onChange={(e) =>
                                  handleChange(e?.value, "dateEndMin")
                                }
                                value={
                                  timeMinutes?.findIndex(
                                    (item) =>
                                      item?.value == eventInputs?.dateEndMin,
                                  ) != -1
                                    ? timeMinutes[
                                        timeMinutes?.findIndex(
                                          (item) =>
                                            item?.value ==
                                            eventInputs?.dateEndMin,
                                        )
                                      ]
                                    : // : timeMinutes[0]
                                      null
                                }
                                isClearable
                              />
                              {error?.dateEndHour ? (
                                <div className="login-validation">
                                  {error?.dateEndHour}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="add_hcp_boxes create-change-content">
                      <div className="form_action">
                        <h4>Event Set-up</h4>
                        <Row>
                          <Col md={12}>
                            <div className="form-group d-flex align-items-center">
                              <label htmlFor="">
                                Event Type <span>*</span>
                              </label>

                              <Select
                                options={eventOptions}
                                className={
                                  error?.event_type
                                    ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                    : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                }
                                placeholder="Select event type"
                                onChange={(e) =>
                                  handleChange(e?.value, "event_type")
                                }
                                value={
                                  eventOptions
                                    ? (() => {
                                        let type = eventInputs?.event_type;
                                        // If type is 'Webinar' or 'Online', treat as 'Online'
                                        if (
                                          type === "Webinar" ||
                                          type === "Online"
                                        ) {
                                          type = "Online";
                                        }
                                        const idx = eventOptions.findIndex(
                                          (item) => item?.value == type,
                                        );
                                        return idx !== -1
                                          ? eventOptions[idx]
                                          : "";
                                      })()
                                    : ""
                                }
                                isClearable
                                // maxMenuHeight={250} // Increase height to fit at least 5 items
                                // menuPlacement="auto"
                              />
                              {error?.event_type ? (
                                <div className="login-validation">
                                  {error?.event_type}
                                </div>
                              ) : null}
                            </div>
                            {eventInputs.event_type != "" && (
                              <>
                                <Form.Text>
                                  <h4>Event Options</h4>
                                  <p>
                                    Choose the options you'd like to include in
                                    your event by dragging them to the right
                                    side.
                                  </p>
                                </Form.Text>
                                <DragDropModal
                                  moduleGroups={
                                    moduleGroups[
                                      eventInputs.event_type === "Webinar"
                                        ? "Online"
                                        : eventInputs.event_type
                                    ]
                                  }
                                  initialDroppedModules={draggedModules}
                                  onDataUpdate={handleDragDropDataUpdate}
                                  resetTrigger={resetKey}
                                  error={error}
                                />
                              </>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                    {eventInputs?.event_type != "" && (
                      <div className="add_hcp_boxes create-change-content">
                        <div className="form_action">
                          <Row>
                            {eventInputs?.event_type !== "On-Site" &&
                              (draggedModules?.activeConference?.includes(
                                "Live Stream",
                              ) ||
                                draggedModules?.inOnlineEvent?.includes(
                                  "Live Stream",
                                )) && (
                                <>
                                  <h4>Live Streaming</h4>
                                  <Col md={12}>
                                    <div className="form-group d-flex align-items-center">
                                      <label htmlFor="">
                                        Streaming Channel <span>*</span>
                                      </label>

                                      <Select
                                        options={getFilteredStreamingOptions()}
                                        className={
                                          error?.stream_type
                                            ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                            : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        }
                                        placeholder="Select streaming type"
                                        onChange={(e) =>
                                          handleChange(e?.value, "stream_type")
                                        }
                                        value={
                                          eventInputs?.stream_type !== undefined
                                            ? getFilteredStreamingOptions().find(
                                                (item) =>
                                                  item?.value ===
                                                    streamTypeMap[
                                                      eventInputs?.stream_type
                                                    ] ||
                                                  item?.value ===
                                                    eventInputs?.stream_type,
                                              ) || null
                                            : null
                                        }
                                        isClearable
                                      />
                                      {error?.stream_type ? (
                                        <div className="login-validation">
                                          {error?.stream_type}
                                        </div>
                                      ) : null}
                                    </div>
                                  </Col>

                                  {eventInputs?.stream_type === "Zoom" ||
                                  streamTypeMap[eventInputs?.stream_type] ===
                                    "Zoom" ||
                                  eventInputs?.stream_type ===
                                    "Zoom Conference" ||
                                  streamTypeMap[eventInputs?.stream_type] ===
                                    "Zoom Conference" ? (
                                    <Col md={12}>
                                      <div className="form-group d-flex align-items-start">
                                        <label htmlFor="">Interpretation</label>
                                        <div className="zoom-interpretation">
                                          <div className="switch">
                                            <label className="switch-light">
                                              <input
                                                type="checkbox"
                                                checked={
                                                  eventInputs
                                                    ?.language_interpretation
                                                    ?.enable || false
                                                } // Use the correct state
                                                onChange={(e) =>
                                                  handleChange(
                                                    e.target.checked,
                                                    "interpretation",
                                                  )
                                                }
                                              />
                                              <span>
                                                <span className="switch-btn active">
                                                  No
                                                </span>
                                                <span className="switch-btn">
                                                  Yes
                                                </span>
                                              </span>
                                              <a className="btn"></a>
                                            </label>
                                          </div>
                                          {eventInputs?.language_interpretation
                                            ?.enable &&
                                            (eventInputs?.stream_type ===
                                              "Zoom" ||
                                              streamTypeMap[
                                                eventInputs?.stream_type
                                              ] === "Zoom" ||
                                              eventInputs?.stream_type ===
                                                "Zoom Conference" ||
                                              streamTypeMap[
                                                eventInputs?.stream_type
                                              ] === "Zoom Conference") && (
                                              <>
                                                {/* {eventInputs?.language_interpretation?.interpreters.map(
                                            (interpreter, index) => ( */}
                                                <Col
                                                  md={12}
                                                  className="interpretation-row suggestions-container"
                                                >
                                                  <div className="suggestion-header">
                                                    <h5>Interpreters info:</h5>
                                                  </div>
                                                  {eventInputs?.language_interpretation?.interpreters.map(
                                                    (interpreter, index) => (
                                                      <Row key={index}>
                                                        <div className="col interpretation-email">
                                                          <div className="form-group flex-column">
                                                            {index === 0 && (
                                                              <label htmlFor="">
                                                                Interpreter's
                                                                email
                                                              </label>
                                                            )}
                                                            <div className="d-flex align-items-center">
                                                              <div className="count">
                                                                {index + 1}.
                                                              </div>
                                                              <input
                                                                type="email"
                                                                name="interpreterEmail"
                                                                placeholder="Interpreter's email"
                                                                className={
                                                                  error?.[
                                                                    `interpreterEmail${index}`
                                                                  ]
                                                                    ? "form-control error"
                                                                    : "form-control"
                                                                }
                                                                value={
                                                                  interpreter.email
                                                                }
                                                                onChange={(e) =>
                                                                  handleChange(
                                                                    e,
                                                                    "interpreterEmail",
                                                                    index,
                                                                  )
                                                                }
                                                                onBlur={() =>
                                                                  handleBlur(
                                                                    index,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !!data?.raw_description &&
                                                                  JSON.parse(
                                                                    data.raw_description,
                                                                  )?.language_interpretation?.interpreters?.some(
                                                                    (item) =>
                                                                      item.email ===
                                                                      interpreter.email,
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                            {error?.[
                                                              `interpreterEmail${index}`
                                                            ] && (
                                                              <div className="login-validation">
                                                                {
                                                                  error?.[
                                                                    `interpreterEmail${index}`
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <div className="col interpretation-language">
                                                          <div className="form-group flex-column">
                                                            {index === 0 && (
                                                              <label htmlFor="">
                                                                Language Spoken
                                                              </label>
                                                            )}
                                                            <Select
                                                              options={
                                                                PrimaryLanguages
                                                              }
                                                              className={
                                                                error?.[
                                                                  `primaryLanguage${index}`
                                                                ]
                                                                  ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                                                  : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                                              }
                                                              // value={PrimaryLanguages.find(
                                                              //   (opt) =>
                                                              //     opt.value ===
                                                              //     (interpreter.languages?.split(
                                                              //       ","
                                                              //     )[0] || "US") // Default to English
                                                              // )}

                                                              value={PrimaryLanguages.find(
                                                                (opt) =>
                                                                  opt.value ===
                                                                  interpreter.languages?.split(
                                                                    ",",
                                                                  )[0],
                                                              )}
                                                              placeholder="Select primary language"
                                                              onChange={(
                                                                selected,
                                                              ) =>
                                                                handleChange(
                                                                  selected,
                                                                  "primaryLanguage",
                                                                  index,
                                                                )
                                                              }
                                                              isClearable={
                                                                false
                                                              }
                                                              onBlur={() =>
                                                                handleBlur(
                                                                  index,
                                                                )
                                                              } // Check validation on focus out
                                                              isDisabled={
                                                                !!data?.raw_description &&
                                                                JSON.parse(
                                                                  data.raw_description,
                                                                )?.language_interpretation?.interpreters?.some(
                                                                  (item) =>
                                                                    item.languages
                                                                      ?.split(
                                                                        ",",
                                                                      )[1]
                                                                      ?.trim() ===
                                                                    interpreter.languages
                                                                      ?.split(
                                                                        ",",
                                                                      )[1]
                                                                      ?.trim(), // Ensure trimmed values match
                                                                )
                                                              }
                                                            />
                                                            {error?.[
                                                              `primaryLanguage${index}`
                                                            ] && (
                                                              <div className="login-validation">
                                                                {
                                                                  error?.[
                                                                    `primaryLanguage${index}`
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <div className="col interpretation-translated">
                                                          <div className="form-group flex-column">
                                                            {index === 0 && (
                                                              <label htmlFor="">
                                                                Translated To
                                                              </label>
                                                            )}
                                                            <Select
                                                              options={
                                                                ConvertedLanguages
                                                              }
                                                              className={
                                                                error?.[
                                                                  `convertedLanguage${index}`
                                                                ]
                                                                  ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                                                  : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                                              }
                                                              value={ConvertedLanguages.find(
                                                                (opt) =>
                                                                  opt.value ===
                                                                  interpreter.languages?.split(
                                                                    ",",
                                                                  )[1],
                                                              )}
                                                              placeholder="Select language"
                                                              onChange={(
                                                                selected,
                                                              ) =>
                                                                handleChange(
                                                                  selected,
                                                                  "convertedLanguage",
                                                                  index,
                                                                )
                                                              }
                                                              isClearable={
                                                                false
                                                              }
                                                              onBlur={() =>
                                                                handleBlur(
                                                                  index,
                                                                )
                                                              } // Check validation on focus out
                                                              isDisabled={
                                                                !!data?.raw_description &&
                                                                JSON.parse(
                                                                  data.raw_description,
                                                                )?.language_interpretation?.interpreters?.some(
                                                                  (item) =>
                                                                    item.languages
                                                                      ?.split(
                                                                        ",",
                                                                      )[1]
                                                                      ?.trim() ===
                                                                    interpreter.languages
                                                                      ?.split(
                                                                        ",",
                                                                      )[1]
                                                                      ?.trim(), // Ensure trimmed values match
                                                                )
                                                              }
                                                            />
                                                            {error?.[
                                                              `convertedLanguage${index}`
                                                            ] && (
                                                              <div className="login-validation">
                                                                {
                                                                  error?.[
                                                                    `convertedLanguage${index}`
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <Col
                                                          md={1}
                                                          className="align-items-start d-flex delete-icon"
                                                        >
                                                          {index === 0 && (
                                                            <label htmlFor=""></label>
                                                          )}
                                                          {eventInputs
                                                            ?.language_interpretation
                                                            ?.interpreters
                                                            ?.length > 1 &&
                                                            !(
                                                              !!data?.raw_description &&
                                                              JSON.parse(
                                                                data.raw_description,
                                                              )?.language_interpretation?.interpreters?.some(
                                                                (item) =>
                                                                  item.email ===
                                                                  interpreter.email,
                                                              )
                                                            ) && (
                                                              <div className="clear-search">
                                                                <button
                                                                  className="delete-button"
                                                                  onClick={(
                                                                    e,
                                                                  ) =>
                                                                    deleteInterpretator(
                                                                      e,
                                                                      index,
                                                                    )
                                                                  }
                                                                >
                                                                  <img
                                                                    src={
                                                                      path_image +
                                                                      "delete-icon.svg"
                                                                    }
                                                                    alt="Delete"
                                                                  />
                                                                </button>
                                                              </div>
                                                            )}
                                                        </Col>
                                                      </Row>
                                                    ),
                                                  )}
                                                </Col>
                                                {/* )
                                          )} */}

                                                <span
                                                  className="add-choice"
                                                  onClick={(e) =>
                                                    addNewInterpretator(
                                                      e,
                                                      "language_interpretation",
                                                    )
                                                  }
                                                >
                                                  Add interpreter
                                                  <img
                                                    src={
                                                      path_image +
                                                      "add-choice-voilet-new.svg"
                                                    }
                                                    alt=""
                                                  />
                                                </span>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                    </Col>
                                  ) : null}

                                  {(streamTypeMap[eventInputs?.stream_type] ===
                                    "Webex" ||
                                    streamTypeMap[eventInputs?.stream_type] ===
                                      "One Source" ||
                                    eventInputs?.stream_type === "Webex" ||
                                    eventInputs?.stream_type ===
                                      "One Source") && (
                                    <Col md={12}>
                                      <div
                                        className="form-group d-flex align-items-start"
                                        style={{ margin: "0" }}
                                      >
                                        <label htmlFor=""></label>
                                        <div className="zoom-interpretation extra-webex">
                                          <div className="interpretation-row suggestions-container">
                                            <div className="suggestion-header">
                                              <h5>Streaming info:</h5>
                                            </div>
                                            <Row>
                                              <Col md={6}>
                                                <div className="form-group flex-column">
                                                  <label htmlFor="">
                                                    Meeting ID
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name="meeting_id"
                                                    placeholder="Meeting ID"
                                                    className={
                                                      error?.meeting_id
                                                        ? "form-control error"
                                                        : "form-control"
                                                    }
                                                    onChange={(e) =>
                                                      handleChange(e)
                                                    }
                                                    value={
                                                      eventInputs?.meeting_id
                                                        ? eventInputs?.meeting_id
                                                        : ""
                                                    }
                                                  />
                                                </div>
                                              </Col>
                                              <Col md={6}>
                                                <div className="form-group flex-column">
                                                  <label htmlFor="">
                                                    Passcode
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name="meeting_pass"
                                                    placeholder="Passcode"
                                                    className={
                                                      error?.meeting_pass
                                                        ? "form-control error"
                                                        : "form-control"
                                                    }
                                                    onChange={(e) =>
                                                      handleChange(e)
                                                    }
                                                    value={
                                                      eventInputs?.meeting_pass
                                                        ? eventInputs?.meeting_pass
                                                        : ""
                                                    }
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  )}

                                  {eventInputs?.stream_type === "Third party" ||
                                  eventInputs?.stream_type === "Third Party" ||
                                  eventInputs?.stream_type == "4" ? (
                                    <Col md={12}>
                                      <div
                                        className="form-group d-flex align-items-start"
                                        style={{ margin: "0" }}
                                      >
                                        <label htmlFor=""></label>
                                        <div className="zoom-interpretation extra-webex">
                                          <div className="interpretation-row suggestions-container">
                                            <div className="suggestion-header">
                                              <h5>Streaming info:</h5>
                                            </div>
                                            <Row>
                                              <Col md={12}>
                                                <div className="form-group flex-column">
                                                  <label htmlFor="">
                                                    Streaming URL
                                                  </label>
                                                  <input
                                                    style={{ maxWidth: "100%" }}
                                                    type="text"
                                                    name="streaming_url"
                                                    placeholder="Streaming URL"
                                                    className={
                                                      error?.streaming_url
                                                        ? "form-control error"
                                                        : "form-control"
                                                    }
                                                    onChange={(e) =>
                                                      handleChange(e)
                                                    }
                                                    value={
                                                      eventInputs?.streaming_url
                                                        ? eventInputs?.streaming_url
                                                        : ""
                                                    }
                                                  />
                                                  {error?.streaming_url ? (
                                                    <div className="login-validation">
                                                      {error?.streaming_url}
                                                    </div>
                                                  ) : null}
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : null}
                                  {eventInputs?.is_client_stream == "Yes" ? (
                                    <Col md={12}>
                                      <div className="form-group d-flex align-items-center">
                                        <label htmlFor="">
                                          Client Stream URL <span> *</span>
                                        </label>
                                        <input
                                          type="text"
                                          name="client_stream_url"
                                          placeholder="Event url"
                                          className={
                                            error?.client_stream_url
                                              ? "form-control error"
                                              : "form-control"
                                          }
                                          onChange={(e) => handleChange(e)}
                                          value={
                                            eventInputs?.client_stream_url
                                              ? eventInputs?.client_stream_url
                                              : ""
                                          }
                                        />
                                        {error?.client_stream_url ? (
                                          <div className="login-validation">
                                            {error?.client_stream_url}
                                          </div>
                                        ) : null}
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {streamTypeMap[eventInputs?.stream_type] ===
                                    "Zoom" && (
                                    <>
                                      <div className="form-group d-flex align-items-center">
                                        <label htmlFor="">Meeting ID</label>
                                        <input
                                          type="text"
                                          name="meeting_id"
                                          placeholder="Enter Meeting ID"
                                          className={
                                            error?.meeting_id
                                              ? "form-control error"
                                              : "form-control"
                                          }
                                          onChange={(e) => handleChange(e)}
                                          value={eventInputs?.meeting_id || ""}
                                          disabled
                                        />
                                        {error?.meeting_id ? (
                                          <div className="login-validation">
                                            {error?.meeting_id}
                                          </div>
                                        ) : null}
                                      </div>

                                      <div className="form-group d-flex align-items-center">
                                        <label htmlFor="">Passcode</label>
                                        <input
                                          type="text"
                                          name="meeting_pass"
                                          placeholder="Enter Passcode"
                                          className={
                                            error?.meeting_pass
                                              ? "form-control error"
                                              : "form-control"
                                          }
                                          onChange={(e) => handleChange(e)}
                                          value={
                                            eventInputs?.meeting_pass || ""
                                          }
                                          disabled
                                        />
                                        {error?.meeting_pass ? (
                                          <div className="login-validation">
                                            {error?.meeting_pass}
                                          </div>
                                        ) : null}
                                      </div>
                                    </>
                                  )}
                                  {localStorage.getItem("user_id") ==
                                  "B7SHpAc XDXSH NXkN0rdQ==" ? (
                                    <Col md={12}>
                                      <div className="form-group d-flex align-items-center">
                                        <label htmlFor="">IBU</label>

                                        <Select
                                          options={ibuOptions}
                                          className={
                                            error?.type
                                              ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                              : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          }
                                          onChange={(e) =>
                                            handleChange(e?.value, "type")
                                          }
                                          placeholder="Select IBU"
                                          value={
                                            ibuOptions
                                              ? ibuOptions.findIndex(
                                                  (item) =>
                                                    item?.value ==
                                                    eventInputs?.type,
                                                ) != -1
                                                ? ibuOptions[
                                                    ibuOptions.findIndex(
                                                      (item) =>
                                                        item?.value ==
                                                        eventInputs?.type,
                                                    )
                                                  ]
                                                : ""
                                              : ""
                                          }
                                          isClearable
                                        />
                                        {error?.type ? (
                                          <div className="login-validation">
                                            {error?.type}
                                          </div>
                                        ) : null}
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}

                            {!(
                              eventInputs?.stream_type === "No streaming" ||
                              eventInputs?.event_type === "On-Site"
                            ) &&
                              (draggedModules?.activeConference?.includes(
                                "Live Stream",
                              ) ||
                                draggedModules?.inOnlineEvent?.includes(
                                  "Live Stream",
                                )) && (
                                <div className="col-12 col-md-12">
                                  <div className="form-group d-flex align-items-center">
                                    <label htmlFor="">
                                      Streaming features{" "}
                                    </label>
                                    <div
                                      className={
                                        error?.streamingFeature
                                          ? "d-flex flex-row gap-5 error"
                                          : "d-flex flex-row gap-5"
                                      }
                                    >
                                      {filteredStreamingOptions.map(
                                        (option) => (
                                          <div
                                            className="form-check include-event"
                                            key={option.value}
                                          >
                                            <label className="form-check-label">
                                              <input
                                                type="checkbox"
                                                value={option.value}
                                                checked={(
                                                  eventInputs?.streamingFeature ||
                                                  []
                                                ).includes(option.value)}
                                                onChange={(e) =>
                                                  handleChange(
                                                    e,
                                                    "streamingFeature",
                                                  )
                                                }
                                              />
                                              {option.label}
                                              <LinkWithTooltip
                                                tooltip={option.tooltip}
                                              >
                                                <img
                                                  src={
                                                    path_image +
                                                    "info_circle_icon.svg"
                                                  }
                                                  alt="tooltip-btn"
                                                  style={{
                                                    marginLeft: "5px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </LinkWithTooltip>
                                            </label>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                    {error?.streamingFeature && (
                                      <div className="login-validation">
                                        {error?.streamingFeature}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}

                            {/* <Col md={12}>
                                <div className="form-group d-flex align-items-center">
                                  <label htmlFor="">Modules included
                                  </label>
                                  <div
                                    className={
                                      error?.sectionInclude
                                        ? "d-flex flex-row gap-5 error"
                                        : "d-flex flex-row gap-5"
                                    }
                                  >
                                    {SectionOptions
                                      .filter((option) =>
                                        !((eventInputs?.stream_type === "No streaming" || eventInputs?.stream_type === "0" || eventInputs?.event_type === "On-Site") && option.value === "Live Stream")
                                      )
                                      .map((option) => (
                                        <div className="form-check include-event" key={option.value}>
                                          <label className="form-check-label">
                                          <input
                                            type="checkbox"
                                            value={option.value}
                                            checked={(eventInputs?.sectionInclude || []).includes(option.value)}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const checked = e.target.checked;
                                              let updatedSectionInclude = [...(eventInputs?.sectionInclude || [])];

                                              if (checked) {
                                                updatedSectionInclude.push(value);
                                              } else {
                                                updatedSectionInclude = updatedSectionInclude.filter(v => v !== value);
                                              }

                                              let updatedStreamType = eventInputs?.stream_type;
                                              if (!checked && value === "Live Stream") {
                                                updatedStreamType = "0";
                                              }

                                              setEventInputs({
                                                ...eventInputs,
                                                sectionInclude: updatedSectionInclude,
                                                stream_type: updatedStreamType,
                                              });
                                            }}
                                          />

                                          {option.label}</label>
                                        </div>
                                      ))}
                                  </div>
                                  {error?.sectionInclude && (
                                    <div className="login-validation">{error?.sectionInclude}</div>
                                  )}
                                </div>
                              </Col> */}
                           <Col md={12}>
                                <div className="form-group d-flex align-items-start">
                                  <label htmlFor="" style={{margin:"12px 0 0"}}>
                                    {isMena ? "Unique URL Code " : "URL identifier"} <span>* </span> <a><img src={path_image + "info_circle_icon.svg"} alt="tooltip-icon" style={{ cursor: "pointer" }} /></a>
                                    <div className="unique-url">
                                        <div >
                                          <p >
                                            A unique name added to the event URL to help identify it. Example: 'CONF2025'
                                          </p>
                                          <img
                                            src={path_image + "url-identifier.png"}
                                            alt="Event Preview"
                                            style={{ width: "100%", borderRadius: "6px" }}
                                          />
                                        </div>
                                    </div>


                                    {/* <div style={{ position: "relative", display: "inline-block" }}>
                                      <LinkWithTooltip
                                        tooltip={
                                          <p style={{ marginBottom: "8px" }}>
                                            A unique name added to the event URL to help identify it. Example: 'CONF2025'
                                          </p>
                                        }
                                      >
                                        <img
                                          src={path_image + "info_circle_icon.svg"}
                                          alt="tooltip-icon"
                                          style={{ cursor: "pointer" }}
                                          className="tooltip-trigger-icon"
                                        />
                                      </LinkWithTooltip>

                                      {/* Image that appears on hover */}
                                      {/* <img
                                        src={path_image + "url-identifier.png"}
                                        alt="Tooltip Preview"
                                        className="tooltip-image"
                                      />
                                    </div> */}

                                  </label>
                                  <div className="suggestion-box">
                                  <input
                                    type="text"
                                    name="event_code"
                                    placeholder={
                                      isMena
                                        ? "Enter Unique URL Code"
                                        : "URL identifier"
                                    }
                                    className={
                                      error?.event_code
                                        ? "form-control error"
                                        : "form-control"
                                    }
                                    onChange={(e) => handleChange(e)}
                                    value={
                                      eventInputs?.event_code
                                        ? eventInputs?.event_code
                                        : ""
                                    }
                                  />
                                  {titleBlurredOnce && suggestions.length > 0 && (
                                  <div className="suggestions-container">
                                    <div className="suggestion-header">
                                      <h5>Suggestions:</h5>
                                    </div>
                                        <div className="form-check include-event event-code">
                                    {suggestions.map((code, index) => (
                                          <label key={index}
                                          // className="suggestion-pill"
                                          className={`suggestion-pill ${
                                            eventInputs?.event_code === code ? "selected-code" : ""
                                          }`}
                                          >
                                        <input
                                          type="radio"
                                          name="event_code_suggestion"
                                          value={code}
                                          checked={eventInputs?.event_code === code}
                                          onChange={() => handleSuggestionSelect(code)}
                                        />
                                        {code}
                                        {eventInputs?.event_code != code ?<img
                                          src={path_image + "filter-close-blue.svg"}
                                          alt="Close-filter"
                                          // onClick={() => removeTagFinal(index, "remove")}
                                        />:null}
                                      </label>
                                        ))}
                                        </div>
                                        </div>
                                  )}
                                  </div>
                                  {error?.event_code ? (
                                    <div className="login-validation">
                                      {error?.event_code}
                                    </div>
                                  ) : null}
                                </div>
                              </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                  </>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            type="button"
            className="btn btn-primary save btn-bordered"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary save btn-filled"
            onClick={(e) => {
              saveClicked(e);
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={open} className="send-confirm" id="resend-confirm">
        <Modal.Header>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            onClick={() => {
              cancelPopup();
            }}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-code">
            {meetingData?.meeting_id ? (
              <h4>
                Meeting Id:{" "}
                <span>
                  {meetingData?.meeting_id}{" "}
                  <span
                    className="copy-content"
                    onClick={() => copyToClipboard(meetingData?.meeting_id)}
                  >
                    <img src={path_image + "copy-content.svg"} alt="Copy" />
                  </span>
                </span>
              </h4>
            ) : null}

            {meetingData?.passcode ? (
              <h4>
                Passcode:
                <span>
                  {meetingData?.passcode}{" "}
                  <span
                    className="copy-content"
                    onClick={() => copyToClipboard(meetingData?.passcode)}
                  >
                    <img src={path_image + "copy-content.svg"} alt="Copy" />
                  </span>
                </span>
              </h4>
            ) : null}

            {meetingData?.join_url ? (
              <h4>
                Join URL:
                {/* <a>{meetingData?.join_url}</a> */}
                <span>
                  <a
                    href={meetingData?.join_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {meetingData?.join_url}
                  </a>
                  <span
                    className="copy-content"
                    onClick={() => copyToClipboard(meetingData?.join_url)}
                  >
                    <img src={path_image + "copy-content.svg"} alt="Copy" />
                  </span>
                </span>
              </h4>
            ) : null}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default CommonAddEventModelNew;
